export default __webpack_public_path__ + "static/metaBusinessPartner-3ecb5c23b6947b43235b00681912ea7a.png";